import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Table } from 'reactstrap';
import { ButtonWithConfirmation } from '../../../components/common/ButtonWithConfirmation';
import { isSysAdminSelector } from '../../../components/System/selectors';
import { userGroupDetailSelector } from '../selectors';
import { ugtsLoad, ugtsSubscribe, ugtsUnubscribe } from './actions';
import { ugtsEntitySelector } from './selectors';
import { SectionHeading, Section } from '../../../components/common/Section';
import { UserGroupTournamentSubscription } from '../../../services/betting';

interface Props {
    ugId: string;
}

export const UserGroupTournamentSubscriptions = (props: Props) => {
    const tournamentSubscriptions = useSelector(ugtsEntitySelector);
    const isSysAdmin = useSelector(isSysAdminSelector);
    const userGroupDetail = useSelector(userGroupDetailSelector);

    const dispatch = useDispatch();

    const onLoad = useCallback(() => {
        dispatch(ugtsLoad(props.ugId));
    }, [dispatch, props.ugId]);

    const isGroupAdmin = () => {
        return (userGroupDetail && userGroupDetail.loginUserIsGroupAdmin) || isSysAdmin;
    };

    const onUnsubscribe = (ugId: string, tId: string) => {
        dispatch(ugtsUnubscribe({ ugId, tId }));
    };

    const onSubscribe = (ugId: string, tId: string) => {
        dispatch(ugtsSubscribe({ ugId, tId }));
    };

    useEffect(() => onLoad(), [onLoad]);

    const renderUgts = (t: UserGroupTournamentSubscription) => {
        return (
            <tr key={t.tournamentId}>
                <td>{t.tournamentName}</td>
                {isGroupAdmin() && (
                    <td>
                        {t.subscribed && t.deletable && (
                            <ButtonWithConfirmation
                                onOK={() => onUnsubscribe(t.userGroupId, t.tournamentId)}
                                color="link"
                                title="Turnier entfernen"
                                message="Sind Sie sicher, dass das Tippteam dieses Turnier nicht mehr tippen möchte?"
                            >
                                entfernen
                            </ButtonWithConfirmation>
                        )}
                        {!t.subscribed && userGroupDetail && (
                            <Button color="link" onClick={() => onSubscribe(String(t.userGroupId), t.tournamentId)}>
                                hinzufügen
                            </Button>
                        )}
                    </td>
                )}
            </tr>
        );
    };

    return (
        <>
            { ( tournamentSubscriptions != null && tournamentSubscriptions.length > 0) && (
            <Section>
                <SectionHeading>Turnierteilnahmen</SectionHeading>
                <Table>
                    <tbody>{tournamentSubscriptions.map(t => renderUgts(t))}</tbody>
                </Table>
            </Section>
            ) }
        </>
    );
};
